<template></template>
<script>
import store from "../store";
import calendar from "~/assets/libs/calendar";
const zmArray = [
  "猪",
  "狗",
  "鸡",
  "猴",
  "羊",
  "马",
  "蛇",
  "龙",
  "兔",
  "虎",
  "牛",
  "鼠"
];
const lhcNumbArray = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
  "32",
  "33",
  "34",
  "35",
  "36",
  "37",
  "38",
  "39",
  "40",
  "41",
  "42",
  "43",
  "44",
  "45",
  "46",
  "47",
  "48",
  "49"
];
const lscNumbArray = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
  "32",
  "33",
  "34",
  "35",
  "36",
  "37",
  "38",
  "39",
  "40",
  "41",
  "42",
  "43",
  "44",
  "45",
  "46",
  "47",
  "48",
  "49",
  "50",
  "51",
  "52",
  "53",
  "54",
  "55",
  "56",
  "57", 
  "58", 
  "59",
  "60"
];
export default {
  data() {
    return {
      sebo: [
        {
          code: "red",
          list: [
            "01",
            "02",
            "07",
            "08",
            "12",
            "13",
            "18",
            "19",
            "23",
            "24",
            "29",
            "30",
            "34",
            "35",
            "40",
            "45",
            "46",
            '51',
            '56',
            '57'
          ]
        },
        {
          code: "blue",
          list: [
            "03",
            "04",
            "09",
            "10",
            "14",
            "15",
            "20",
            "25",
            "26",
            "31",
            "36",
            "37",
            "41",
            "42",
            "47",
            "48",
            '52',
            '53',
            '58',
            '59'
          ]
        },
        {
          code: "green",
          list: [
            "05",
            "06",
            "11",
            "16",
            "17",
            "21",
            "22",
            "27",
            "28",
            "32",
            "33",
            "38",
            "39",
            "43",
            "44",
            "49",
            '50',
            '54',
            '55',
            '60'
          ]
        }
      ]
    };
  },
  methods: {
    mixinFindNumbAnimal(numb, animal) {
      //找出该号码的生肖
      let sx = animal.find((e) => e.list.includes(numb))
      return (sx && sx.name) || ''
    },
    mixinFindNumbColor(numb, pcdd = false) {
      //找出该号码的色波
      let color = this.sebo.find((e) => e.list.includes(numb))
      if (pcdd) color = this.PCDDTM.find((e) => e.list.includes(numb))
      return (color && color.code) || ''
    },
    mixinFindNumbColorText(numb) {
      //找出该号码的色波汉字
      let color = this.sebo.find((e) => e.list.includes(numb))
      return (color && color.text) || ''
    },
    createLhcArray(year) {
      let subYear = year - 2019;
      let lhcArray = zmArray.map(item => {
        return {
          name: item,
          list: []
        };
      });

      for (let i = 0; i < lhcNumbArray.length; i++) {
        let index = (i + (12 - subYear)) % 12;
        lhcArray[index].list.push(lhcNumbArray[i]);
      }
      return lhcArray;
    },
    createLscArray(year) {
      let subYear = year - 2019;
      let lscArray = zmArray.map((item) => {
        return {
          name: item,
          list: []
        }
      })

      for (let i = 0; i < lscNumbArray.length; i++) {
        let index = (i + (12 - subYear)) % 12;
        lscArray[index].list.push(lscNumbArray[i])
      }
      return lscArray;
    },
    /**
     * date 必须是Date()类型
     */
    getCurrYearAnimal(date, lotteryTypeCode = 'lhc') {
      var currDate = new Date();

      if (date && date instanceof Date) {
        currDate = date;
      } else {
        const serviceTime = store.state.service.serviceTime;
        currDate = new Date(serviceTime);
      }

      let cYear = currDate.getFullYear();
      let cMonth = currDate.getMonth() + 1;
      let cDay = currDate.getDate();
      const lYear = calendar.solar2lunar(cYear, cMonth, cDay).lYear;

      let animal = []
      if (lotteryTypeCode.toLowerCase() == 'lsc') {
        animal = this.createLscArray(lYear);
      } else {
        animal = this.createLhcArray(lYear);
      }
      return animal;
    },
    findNumbColor(numb) {
      //找出该号码的色波
      let color = this.sebo.find(e => e.list.includes(numb));
      return (color && color.code) || "";
    },
    findNumbAnimal(numb, animal) {  
      //找出该号码的生肖
      let sx = animal.find(e => e.list.includes(String(numb)));
      return (sx && sx.name) || "";
    }
  }
};
</script>